import { render, staticRenderFns } from "./launchScreen.vue?vue&type=template&id=2045f364&scoped=true"
import script from "./launchScreen.vue?vue&type=script&lang=js"
export * from "./launchScreen.vue?vue&type=script&lang=js"
import style0 from "./launchScreen.vue?vue&type=style&index=0&id=2045f364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2045f364",
  null
  
)

export default component.exports